import BlockMix from "@/components/BlockMix/BlockMix";
import { FifthParagraph, FourthTitle, SecondaryTitle } from "@/componentsWP/StyledComponentsLib/StyledComponentsLib";
import styles from './VideoSeries.module.scss'
import { SectionSlider } from "@/componentsWP";
import { Post } from "generated-graphql";
import Back from '/public/svgs/left-arrow.svg';
import Link from "next/link";

const VideoSeries = ({ pageBlocks, seriesParts }: {
  seriesParts: Post[];
  pageBlocks: Post;
}) => {
  const seriesCategory = pageBlocks.categories?.nodes.find(
    (c) => c.parent?.node.name === 'Series',
  );
  return (
    <div style={{ marginTop: 70 }} className={`${seriesCategory?.slug ? styles[seriesCategory?.slug] : ''
      } series-wrapper`}>
      <div
        className={`${styles.series} ${seriesCategory && pageBlocks.categoryBranding?.hideBranding ? styles.noBranding : ''}`}
        style={{
          backgroundImage: seriesCategory && !pageBlocks.categoryBranding?.hideBranding
            ? `url(${seriesCategory?.color?.bannerImage?.mediaItemUrl})`
            : '',

          backgroundColor:
            seriesCategory?.color?.bannerBackground || 'transparent',

        }}
      >
        <div className="container">
          <div
            className={styles.content}
          >
            <Link
              href="/resources"
              className="d-flex align-items-center"
              style={{ marginBottom: 45, color: '#fff', textDecoration: "none" }}
            >
              <Back className={styles.back} />

              <FifthParagraph className="ps-2">
                See all News & Resource
              </FifthParagraph>
            </Link>

            <SecondaryTitle className={styles.seriesName} style={{ color: '#fff', marginBottom: '20px' }}>
              {seriesCategory?.name}
            </SecondaryTitle>
          </div>
        </div>

        <BlockMix
          blocksData={pageBlocks?.editorBlocks}
          acfData={pageBlocks?.builder?.sections}
        />
      </div>

      <div
        style={{
          paddingTop: '96px',
          borderRadius: '16px 16px 0 0 ',
          marginTop: '-20px',
          background: '#fff',
        }}
      >
        <div className="container">
          <FourthTitle
            style={{ textTransform: 'capitalize', marginBottom: '20px' }}
          >
            Explore other {seriesCategory?.name} episodes
          </FourthTitle>
        </div>
        <SectionSlider isSeries={seriesCategory?.slug || ""} items={seriesParts} exclude={pageBlocks.slug || ''} />
      </div>
      <div className={styles.contactSection}>
        <div className='container'>
          <div className={styles.ctaContent}>
            <h3 className='cta-text'>
              If you’re interested in hearing more about the Agent3 Group, get in contact — we’d love to hear from you.
            </h3>
            <Link href="/contact" className='cta'>Contact us</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoSeries;